import React from "react";
import { MDBDataTable } from "mdbreact";

// Redux
import { connect } from "react-redux";
import { showModal } from "./../../../redux/actions/modal";

//Table Helper Controllers
import {
  filterTableData,
  filterDataByColumns,
  TableFetchSelect,
  onTableFetchSelectChange,
  tableFetchSelectOptions,
  modifyIssuesTableRows,
} from "./../../../helpers/tableControllers";

// UI Components
import { Loader } from "../../../UI/Loaders/Loaders";
// import { getAllRepayments } from "../../../redux/actions/loans";
import { getPendingIssues } from "../../../redux/actions/issues";

const PendingIssues = (props) => {
  // Open modal
  const modalHandler = (modalData) => {
    props.showModal(modalData);
  };

  let RenderedComponent = null;

  const { pendingIssuesTableData, loading, error } = props.data;

  //  If issues object is null e.g. Initial component render before API fetch
  if (error || pendingIssuesTableData === undefined) {
    RenderedComponent = (
      <div className="centerLoader">
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Exist Issues
          </h4>
        </div>
      </div>
    );
  } else if (loading) {
    RenderedComponent = <Loader text="Loading pending issues ..." />;
  } else if (pendingIssuesTableData) {
    // Verify that a issues object exists
    if (
      pendingIssuesTableData === undefined ||
      pendingIssuesTableData === null
    ) {
      RenderedComponent = (
        <div centerLoader>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> Problem Fetching Existing Issues,
              Please Reload the Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (pendingIssuesTableData.rows) {
      if (pendingIssuesTableData.rows.length > 0) {
        // If a issues object exists, filter the rows property to reflect selected Tab
        const tableName = "Issues";
        const actions = ["view"];
        const filteredData = filterTableData(
          pendingIssuesTableData,
          "pending",
          tableName
        );
        const { columns, rows } = filteredData;
        let newRows = modifyIssuesTableRows(
          rows,
          tableName,
          actions,
          modalHandler
        );
        let columnFilteredTable = filterDataByColumns(
          {
            columns: columns,
            rows: newRows,
          },
          "exclude",
          ["issue_ref", "pub_date"]
        );
        // pendingIssuesTableData = { ...columnFilteredTable }

        RenderedComponent = (
          <div className="grid__padding">
            <MDBDataTable
              responsive
              minimal="true"
              striped
              bordered
              hover
              data={columnFilteredTable}
            />
          </div>
        );
      } else {
        RenderedComponent = (
          <div className="centerLoader">
            <div className="grid__padding animated speed-1x fadeInRight">
              <h4 className="center-txt p-y-5">
                <i className="fas fa-bell" /> There are Currently No Issues to
                Resolve
              </h4>
            </div>
          </div>
        );
      }
    }
  }

  return (
    <div id="finance" className="table-view animated speed-1x fadeInRight">
      {/*Welcome Block*/}
      <div className="block-header">
        <div className="flex-row">
          <div className="col-lg-6 col-md-6 col-sm-7 dashboard-title">
            <h3 className="m-l-1">
              <aside className="rounder">2</aside>
              &nbsp; Pending Issues
            </h3>
          </div>

          <div>
            <div
              className="m-l-1 m-r-1 m-b-1"
              style={{
                display: "flex",
                justifyContent: "center",
                height: "30px",
              }}
            >
              <TableFetchSelect
                // style={{ marginRight: '20px' }}
                label="Showing results for: "
                id="table-fetch"
                className="table-fetch-select"
                onChange={(e) =>
                  onTableFetchSelectChange(
                    e,
                    props.showModal,
                    props.getPendingIssues,
                    "getPendingIssues",
                    `searchvalue=`
                  )
                }
                options={[...tableFetchSelectOptions]}
              />
            </div>
          </div>
        </div>
        <div>
          {/*Datatable*/}
          <div className="center-container">{RenderedComponent}</div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { showModal, getPendingIssues })(PendingIssues);
